var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"chat"},[_c('p',[_vm._v("Join the "),_c('a',{attrs:{"href":_vm.chat_url}},[_vm._v("competition chat")]),_vm._v(" for support!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }